"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Toggle = require("../../components/Toggle");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Toggle = {
  styles: function styles(theme) {
    var controlWidth = 16;
    var toggleWidth = 16;
    return {
      checkbox: {
        "&:checked ~ $button:after": {
          insetInlineStart: 16
        },
        /**
         * The next selector is because the :disabled and :checked selectors have the same specificity
         * This allows the disabled state colors to override the checked state colors
         */

        "&:checked:not(:disabled)": {
          "& ~ $button": {
            backgroundColor: _Toggle.vars.get("checkboxColor"),
            // On background color
            "&::after": {
              backgroundColor: theme.colors.textOnDark // On toggle color
            }
          }
        },
        "&:disabled:checked ~ $button": {
          backgroundColor: "color-mix(in srgb, ".concat(_Toggle.vars.get("checkboxColor"), ", ").concat(theme.colors.themeBase, ")"),
          "&:after": {
            backgroundColor: "color-mix(in srgb, #fff 60%, ".concat(theme.colors.themeBase, ")"),
            opacity: 0.9
          }
        }
      },
      button: {
        backgroundColor: theme.colors.baseContrast040,
        borderRadius: toggleWidth,
        minWidth: controlWidth * 2,
        minHeight: controlWidth + 4,
        "&:after": {
          backgroundColor: theme.colors.themeBase,
          // Off toggle color
          width: toggleWidth,
          height: toggleWidth,
          insetInlineStart: 2,
          top: 2
        }
      },
      label: {
        color: theme.colors.baseContrast070
      },
      root: {
        "&:hover $checkbox": {
          "&:checked:not(:disabled) ~ $button": {
            backgroundColor: _Toggle.vars.get("rootBackground")
          },
          "&:not(:disabled) ~ $button": {
            backgroundColor: theme.colors.baseContrast050
          }
        }
      },
      description: {
        color: theme.colors.baseContrast070,
        textTransform: "none"
      },
      hint: {
        textTransform: "none"
      }
    };
  }
};
var _default = exports.default = Toggle;